module.exports = __webpack_public_path__ + "assets/img/card-channel.6ab66c5c.png";